var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoactionMapIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 115868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 115350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    filter: "url(#filter0_d_1_204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union 1",
    d: "M10.997 1.5H48.997C50.5883 1.5 52.1144 2.13214 53.2397 3.25736C54.3649 4.38258 54.997 5.9087 54.997 7.5V45.5C54.997 47.0913 54.3649 48.6174 53.2397 49.7426C52.1144 50.8679 50.5883 51.5 48.997 51.5H10.997C9.40571 51.5 7.87959 50.8679 6.75437 49.7426C5.62915 48.6174 4.99701 47.0913 4.99701 45.5V7.5C4.99701 5.9087 5.62915 4.38258 6.75437 3.25736C7.87959 2.13214 9.40571 1.5 10.997 1.5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 115351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 4152",
    d: "M41.249 24.451C41.0417 24.4513 40.8429 24.5337 40.6963 24.6803C40.5497 24.8269 40.4673 25.0257 40.467 25.233V34.091L34.209 36.591V28.362C34.209 28.1546 34.1266 27.9557 33.98 27.809C33.8333 27.6624 33.6344 27.58 33.427 27.58C33.2196 27.58 33.0207 27.6624 32.874 27.809C32.7274 27.9557 32.645 28.1546 32.645 28.362V36.593L26.384 34.09V21.696L30.009 23.146C30.2017 23.2229 30.417 23.2201 30.6077 23.1383C30.7983 23.0564 30.9486 22.9022 31.0255 22.7095C31.1024 22.5168 31.0996 22.3015 31.0178 22.1108C30.9359 21.9202 30.7817 21.7699 30.589 21.693L25.91 19.819H25.897C25.7109 19.744 25.5031 19.744 25.317 19.819H25.303L17.491 22.943C17.346 23.0011 17.2217 23.1014 17.1342 23.2308C17.0467 23.3601 17 23.5128 17 23.669V37.749C17 37.8769 17.0313 38.0028 17.0912 38.1157C17.1512 38.2287 17.2379 38.3252 17.3438 38.3968C17.4497 38.4685 17.5715 38.5131 17.6987 38.5267C17.8258 38.5403 17.9543 38.5226 18.073 38.475L25.604 35.463L33.121 38.47L33.135 38.476C33.3211 38.551 33.5289 38.551 33.715 38.476L33.729 38.47L41.537 35.347C41.6816 35.2881 41.8054 35.1875 41.8926 35.058C41.9799 34.9286 42.0266 34.7761 42.027 34.62V25.229C42.0257 25.0231 41.9433 24.8259 41.7977 24.6803C41.6521 24.5347 41.4549 24.4523 41.249 24.451ZM24.822 34.09L18.564 36.59V24.19L24.822 21.69V34.09ZM36.556 16.629C36.0918 16.629 35.638 16.7666 35.2521 17.0245C34.8661 17.2824 34.5653 17.649 34.3877 18.0778C34.21 18.5067 34.1635 18.9786 34.2541 19.4339C34.3447 19.8891 34.5682 20.3073 34.8964 20.6356C35.2247 20.9638 35.6428 21.1873 36.0981 21.2779C36.5534 21.3685 37.0253 21.322 37.4542 21.1443C37.883 20.9667 38.2496 20.6659 38.5075 20.2799C38.7654 19.894 38.903 19.4402 38.903 18.976C38.9022 18.3538 38.6547 17.7573 38.2147 17.3173C37.7747 16.8773 37.1782 16.6298 36.556 16.629ZM36.556 19.758C36.4013 19.758 36.2501 19.7121 36.1215 19.6262C35.9929 19.5403 35.8927 19.4181 35.8335 19.2753C35.7743 19.1324 35.7589 18.9751 35.789 18.8234C35.8192 18.6717 35.8937 18.5324 36.003 18.423C36.1124 18.3137 36.2517 18.2392 36.4034 18.209C36.5551 18.1788 36.7124 18.1943 36.8553 18.2535C36.9981 18.3127 37.1203 18.4129 37.2062 18.5415C37.2921 18.6701 37.338 18.8213 37.338 18.976C37.3377 19.1833 37.2553 19.3821 37.1087 19.5287C36.9621 19.6753 36.7633 19.7577 36.556 19.758Z",
    fill: "url(#paint0_linear_1_204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 4153",
    d: "M36.556 13.5C35.1042 13.5016 33.7122 14.079 32.6856 15.1056C31.659 16.1322 31.0816 17.5242 31.08 18.976C31.08 21.786 35.473 26.762 35.974 27.321C36.0473 27.4027 36.1371 27.4681 36.2373 27.5128C36.3376 27.5576 36.4462 27.5807 36.556 27.5807C36.6658 27.5807 36.7744 27.5576 36.8747 27.5128C36.9749 27.4681 37.0647 27.4027 37.138 27.321C37.638 26.762 42.032 21.786 42.032 18.976C42.0304 17.5242 41.453 16.1322 40.4264 15.1056C39.3998 14.079 38.0078 13.5016 36.556 13.5ZM36.556 25.6C34.848 23.574 32.645 20.464 32.645 18.971C32.645 17.9337 33.057 16.939 33.7905 16.2055C34.524 15.4721 35.5187 15.06 36.556 15.06C37.5933 15.06 38.588 15.4721 39.3215 16.2055C40.055 16.939 40.467 17.9337 40.467 18.971C40.464 20.466 38.264 23.578 36.556 25.6Z",
    fill: "url(#paint1_linear_1_204)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_204",
    x: 0.997009,
    y: 0.5,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.031 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_204"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_204",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_204",
    x1: 29.5135,
    y1: 16.629,
    x2: 29.5135,
    y2: 38.5322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4584E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CC19C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_204",
    x1: 36.556,
    y1: 13.5,
    x2: 36.556,
    y2: 27.5807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4584E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CC19C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoactionMapIcon);
export default __webpack_public_path__ + "static/media/loaction-map-icon.331330a670d3473039866fecee0ab874.svg";
export { ForwardRef as ReactComponent };